const form = {
    baseStyle: {
        fontWeight: "medium",
        color: "gray.800",
        bg: "transparent",
    },
};
export default form;
